$.ajax({
  type: "GET",
  url: "/cart.js",
  dataType: "json",
  success: function (cartdata) {
    //console.log(cartdata);
    $.each( cartdata.items , function( i, val ) {
      $('.album-btn-desc[data-id="' + val.variant_id + '"]').addClass('purchased').css("pointer-events", "none");
      $('.album-btn-mob[data-id="' + val.variant_id + '"]').addClass('purchased-mob').css("pointer-events", "none");
    });
  },
});

$( '.add-to-cart' ).click(function(event){
  event.preventDefault();
  var $this = $(this);
  var holder = $this.closest('.section-albums__buttons');
  $this.css("pointer-events", "none");
  var ID = $this.data('id'); 
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {
      quantity: 1,
      id: ID
    },
    dataType: 'json', 
    success: function (data) { 
      //console.log(data);
      $.ajax({
        type: "GET",
        url: "/cart.js",
        dataType: "json",
        success: function (cartdata) {
          //console.log(cartdata);
          $(".site-header__cart-count span[data-cart-count]").text(cartdata.item_count);
          holder.find('.album-btn-desc').addClass("purchased");
          holder.find('.album-btn-mob').addClass("purchased-mob");
        },
        error: function(xhr, status, error) {
          holder.find('.album-btn-desc').css("pointer-events", "auto");
          holder.find('.album-btn-mob').css("pointer-events", "auto");
          alert(xhr.responseJSON.description);
        }
      });
    },
    error: function(xhr, status, error) {
      holder.find('.album-btn-desc').css("pointer-events", "auto");
      holder.find('.album-btn-mob').css("pointer-events", "auto");
      alert(xhr.responseJSON.description);
    }
  });
});

// Dropdown
$(".section-category__dropdown-btn").click(function(e) {
  e.preventDefault();

  $(".section-category__dropdown").removeClass("active");

  $(".question__answer").slideUp(200);
  if ($(this).siblings(".section-category__content").is(":hidden")) {
    $(this).parent().addClass("active");
    $(this).siblings(".section-category__content").slideDown(500);

  } else {
    $(this).parent().removeClass("active");
  $(this).siblings(".section-category__content").slideUp(500);
  }
});
// end
// Popup open and close
  var albumPopup = {
  popup: $('.album-popup'),
  closeButton: '.album-popup-close-button',

  movePopup: function(){
    let self = this;
    self.popup.appendTo('body');
    console.log('popup moved');
  },

  openPopup: function(target){
    let self = this;
    $(target).addClass('active');
    console.log('openPopup');
  },

  events: function(){
    let self = this;

    self.popup.on('click',self.closeButton, function(e){
      e.preventDefault();

      self.popup.removeClass('active');
      console.log('popup closed');
    });

    $(document).on('click','.btn-preview', function(e){
      e.preventDefault();  
      console.log($(e.currentTarget).data('id')); 
      let target = '[data-pop-id="'+$(e.currentTarget).data('id')+'"]';

      self.openPopup(target);

    });

  },

  init: function(){
    let self = this;
    self.movePopup();
    self.events();
    console.log('album popup initialized');
  }

}
albumPopup.init();
// end popup open and close

 // add class on text;
$('.section-albums__price-name').on('click', function () {
  var wrapper = $(this).closest('.section-albums__price-block');
  var lineClap = $('.section-albums__price-name')
   console.log(lineClap)
if( wrapper.hasClass('show-text')) {
  wrapper.removeClass('show-text')
}

else {
   wrapper.addClass('show-text') 
}

})
// end add class to text
